module.exports = __webpack_public_path__ + "img/logo.f592b7aa.png";